import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';

// MyBookie pages
import MyBookieLanding from './pages/MyBookie/Landing';
import MyBookieDashboard from './pages/MyBookie/Dashboard';
import MyBookiePrivacy from './pages/MyBookie/Privacy';
import MyBookieTerms from './pages/MyBookie/Terms';
import MyBookiePricing from './pages/MyBookie/Pricing';
import CFOHub from './pages/MyBookie/CFOHub';
import TrustCenter from './pages/MyBookie/TrustCenter';
import Subprocessors from './pages/MyBookie/Subprocessors';
import MyBookieCookieConsent from './pages/MyBookie/MyBookieCookieConsent';
import MyBookieExitPopup from './pages/MyBookie/MyBookieExitPopup';
import AccountantView from './pages/MyBookie/AccountantView';
import ClientPortalView from './pages/MyBookie/ClientPortalView';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ErrorBoundary title="Page Error" message="This page encountered an error. Try refreshing or navigate home.">
            <Routes>
              {/* MyBookie — primary routes */}
              <Route path="/" element={<MyBookieLanding />} />
              <Route path="/dashboard" element={<MyBookieDashboard />} />
              <Route path="/pricing" element={<MyBookiePricing />} />
              <Route path="/cfo" element={<CFOHub />} />
              <Route path="/mybookie/cfo" element={<CFOHub />} />
              <Route path="/privacy" element={<MyBookiePrivacy />} />
              <Route path="/terms" element={<MyBookieTerms />} />
              <Route path="/security" element={<TrustCenter />} />
              <Route path="/subprocessors" element={<Subprocessors />} />

              {/* Legacy /mybookie prefix routes (backwards compatibility) */}
              <Route path="/mybookie" element={<MyBookieLanding />} />
              <Route path="/mybookie/dashboard" element={<MyBookieDashboard />} />
              <Route path="/mybookie/privacy" element={<MyBookiePrivacy />} />
              <Route path="/mybookie/terms" element={<MyBookieTerms />} />
              <Route path="/mybookie/pricing" element={<MyBookiePricing />} />
              <Route path="/mybookie/security" element={<TrustCenter />} />
              <Route path="/mybookie/subprocessors" element={<Subprocessors />} />

              {/* Shared views (public, no auth) */}
              <Route path="/shared/:shareToken" element={<AccountantView />} />
              <Route path="/mybookie/shared/:shareToken" element={<AccountantView />} />

              {/* Client Portal public views */}
              <Route path="/client-portal/:shareToken" element={<ClientPortalView />} />
              <Route path="/client-portal/m/:magicToken" element={<ClientPortalView />} />

              {/* Catch-all — redirect to landing */}
              <Route path="*" element={<MyBookieLanding />} />
            </Routes>
          </ErrorBoundary>
          <MyBookieCookieConsent />
          <MyBookieExitPopup />
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
